import { h, Component } from 'preact';
import GemComponentsView from './gemComponentsView/GemComponentsView';
import s from './scss/gemView.scss';
import cn from 'classnames';

export default class GemView extends Component {
  constructor(props) {
    super(props);
    this.getVPwidth();

    window.addEventListener('resize', () => {
      this.getVPwidth();
    });
  }

  getVPwidth = () => {
    this.setState({
      vw: Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
      ),
      vh: Math.max(
        document.documentElement.clientHeight,
        window.innerHeight || 0
      )
    });
  };

  render() {
    const correctUrl = window.location.href.split('?')[0];
    const absPath =
      process.env.NODE_ENV === 'production'
        ? correctUrl.replace('index.html', '')
        : `${window.location.origin}/`;

    let inlineStyle;
    console.log('DDD', correctUrl)

    if (this.state.vw >= 768) {
      inlineStyle = {
        height: (this.state.vw / 2)
      };
    } else {
      // For Mobile we have ratio of 4:3
      inlineStyle = {
        height: (this.state.vw * 75) / 100
    };
  }
    return (
      <div className={cn(s.wrapper)} style={inlineStyle}>

        <GemComponentsView
          className={s.componentsView}
          vh={this.state.vh}
          vw={this.state.vw}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/gemView/GemView.js